module.exports = __webpack_public_path__ + "img/vo-way-4.7689bbb8.svg";